import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { getBrandConfig, Brands } from '@/brand'
import setBrandConfig from '@/functions/setBrandConfig'

const kebab = (key) => key.replace(/[A-Z]/g, (char) => `-${char.toLowerCase()}`)

export const useBrandStore = defineStore('brand', () => {
  const brand = ref(Brands.Default)

  const brandConfig = computed(() => getBrandConfig(brand.value))
  const translations = computed(() => brandConfig.value.translations)
  const language = computed(() => brandConfig.value.language)
  const isRTL = computed(() => brandConfig.value.isRTL)

  // Brand theme as CSS variables (colorBg -> --color-bg), applied on the app root in App.vue.
  const themeStyle = computed(() =>
    Object.fromEntries(Object.entries(brandConfig.value.theme || {}).map(([key, value]) => [`--${kebab(key)}`, value]))
  )

  function resolveBrandFromHost() {
    brand.value = setBrandConfig()
  }

  return { brand, brandConfig, translations, language, isRTL, themeStyle, resolveBrandFromHost }
})
